/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : actionTypes.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Tahir Shaik - tahir@au79consulting.com
 * @date 11-06-2024
 * @description This file is define different action types to refer/denote what type of action user is trying perform
 */
const actionType = {
  SPINNER_LOADING: "Action for the Spinner Loading",
  SPINNER_LOADED: "Action for the Spinner Loading completed",
  REFRESH_KG_NODES_DECISION_MATRIX:
    "Action to refresh knowledge graph nodes for decision matrix",
  GET_DECISION_MATRIX_AI_SUGGESTIONS: "GET_DECISION_MATRIX_AI_SUGGESTIONS",
  // Authentication Actions
  LOGIN: "POST: logIn",
  FORGOT_PASSWORD: "POST: forgot password",
  RESET_PASSWORD: "POST: reset password",
  SIGN_OUT: "logoutOut",

  // User Management
  GET_COUNTRY_CODES: "Get: get country codes",

  ADD_USER: "Post: add user",
  GET_USERS_LIST: "Get: get users list",
  UPDATE_USER: "Get: update user",
  CHANGE_USER_STATUS: "Put: change user status",
  DELETE_USER: "Put: delete user",
  CHANGE_USER_ROLE: "Put: change user role",
  ADD_ROLE: "Post: add role",
  GET_ROLES_LIST: "Get: get roles list",
  GET_ROLES_LIST_MAIN: "Get: get roles list main",
  UPDATE_ROLE: "Put: update role",
  REMOVE_CHAPTERS: "Put: remove chapters",
  CHANGE_ROLE_STATUS: "Put: change role status",
  DELETE_ROLE: "Put: delete role",
  ADD_PAGE_ACCESS: "Put: add page access",
  REMOVE_PAGE_ACCESS: "Put: remove page access",
  ADD_FEATURE_ACCESS: "Put: add feature access",
  REMOVE_FEATURE_ACCESS: "Put: remove feature access",

  GET_APP_META_DATA: "Get: get app meta data",

  GET_FEATURES_LIST: "Get: get features list",
  // Swagger Response
  GET_SWAGGER_DATA: "Get: Swapper API documentation!",
  //Profile
  GET_PROFILE: "Action for Profile Details",
  UPDATE_PROFILE: "Action for Update Details",
  UPLOAD_PROFILE_PIC: "Action to upload the profile picture",
  GET_PROFILE_PIC: "Action to get the profile picture",
  RESET_PROFILE: "Action for Reset Profile",
  //Countries and PhoneCode
  GET_COUNTRIES_PHONECODE: "Action for Get Countries and Phone Codes",

  //Zone Details
  ADD_ZONES: "Add Zones",
  DELETE_ZONES: "Delete Zones",

  //Architecture Types
  ADD_ARCHITECTURE_TYPES: "Add Architecture Types",
  DELETE_ARCHITECTURE_TYPES: "Delete Architecture Types",

  //Vehicle Class
  ADD_VEHICLE_CLASS: "Action for Add Vehicle Class",
  UPDATE_VEHICLE_CLASS: "Action for Update Vehicle Class",
  DELETE_VEHICLE_CLASS: "Action for Delete Vehicle Class",
  GET_VEHICLE_CLASS: "Action for Get Vehicle Class",
  GET_VEHICLE_INTERACTIONS: "Action for Get Vehicle Interactions",

  //Vehicle Function
  ADD_VEHICLE_FUNCTION: "Action for Add Vehicle Function",
  UPDATE_VEHICLE_FUNCTION: "Action for Update Vehicle Function",
  DELETE_VEHICLE_FUNCTION: "Action for Delete Vehicle Function",
  GET_VEHICLE_FUNCTION: "Action for Get Vehicle Function",

  //Vehicle Status
  ADD_VEHICLE_STATUS: "Action for Add Vehicle Status",
  UPDATE_VEHICLE_STATUS: "Action for Update Vehicle Status",
  GET_VEHICLE_STATUS: "Action for Get Vehicle Status",
  DELETE_VEHICLE_STATUS: "Action for Delete Vehicle Status",

  //Vehicle Systems
  ADD_VEHICLE_SYSTEMS: "Action for Add Vehicle Systems",
  UPDATE_VEHICLE_SYSTEMS: "Action for Update Vehicle Systems",
  GET_VEHICLE_SYSTEMS: "Action for Get Vehicle Systems",
  DELETE_VEHICLE_SYSTEMS: "Action for Delete Vehicle Systems",
  GET_VC_ADD_REQUESTS: "Action for Get vehicle component add requests",

  //Powertrain Class
  ADD_POWETRAIN_CLASS: "Action for Add Powertrain Class",
  UPDATE_POWETRAIN_CLASS: "Action for Update Powertrain Class",
  DELETE_POWETRAIN_CLASS: "Action for Delete Powertrain Class",
  GET_POWETRAIN_CLASS: "Action for Get Powertrain Class",

  //Admin Settings
  GET_ADMIN_SETTINGS: "Action for Get Admin Settings",

  //File Handling
  GET_FILE: "Action for Getting Image and File",
  ADD_FILE: "Action for upload file and Image",
  SET_FILE: "Action for Set Image",

  //Project Config
  ADD_PROJECT: "Action for Add Project",
  GET_PROJECT: "Action for Get Project",
  GET_PROJECTS_MAIN: "Action for Get Projects Main",
  SET_SELECTED_PROJECT_MAIN: "Action to Set Selected Project Main",
  GET_RECREATE_PROJECT: "Action for Recreate Get Project",
  UPDATE_PROJECT: "Action for Update Project",
  UPDATE_PROJECT_STATUS: "Action for Update Project Status",
  RESET_PROJECT_CONFIG: "Action for reset",

  // project with varient
  GET_PROJECT_WITH_VARIANTS_MAIN: "Action for Get Project With Variants Main",

  //Variant
  ADD_VARIANTS: "Action for Add Variant",
  GET_VARIANTS: "Action for Get Variant",
  GET_VARIANTS_MAIN: "Action for Get Variants Main",
  SET_SELECTED_VARIANT_MAIN: "Action to Set Selected Variant Main",
  GET_VARIANTS_RECREATION: "Action for Get ReCreation",
  UPDATE_VS_VARIANT: "Action for Update Vehicle Status for Variant",
  UPDATE_VS_VEHICLE_FUNCTION: "Action for Update Vehicle Function for Variant",
  UPDATE_VS_VEHICLE_COMPONENTS:
    "Action for Update Vehicle Components for Variant",
  UPDATE_VARIANT_COLOR: "Action for update variant color",

  // Change logs
  GET_PROJECT_CHANGE_LOGS: "Action for Get Project Change Logs",
  GET_VARIANT_CHANGE_LOGS: "Action for Get Variant Change Logs",

  // Project Access
  GET_PROJECT_DETAILS_PA: "Action to Get Project Details for Project Access",
  GET_PROJECT_DETAILS_MIND_MAP_PA:
    "Action to Get Project Details Mind Map for Project Access",
  GET_EE_COMPONENTS_PA: "Action to Get EE Components for Project Access",
  GET_SW_MODULES_PA: "Action to Get SW Modules for Project Access",
  // LabCar
  GET_PROJECT_DETAILS: "Action to Get Project Details",
  GET_PROJECT_DETAILS_MIND_MAP: "Action to Get Project Details Mind Map",
  GET_EE_COMPONENTS: "Action to Get EE Components",
  GET_EE_COMPONENTS_COUNT: "Action to Get EE Components Count",
  Add_EE_COMPONENT: "Action to Add EE Component",
  ADD_EE_COMPONENT_DRAFT: "Action to Add EE Component Draft",
  UPDATE_EE_COMPONENT: "Action to Update EE Component",
  REPLACE_EE_COMPONENT: "Action to Replace EE Component",
  GET_SW_MODULES: "Action to Get SW Modules",
  GET_MAIN_SW_MODULES: "Action to Get Main SW Modules",
  GET_LINKED_SW_MODULES: "Action to Get Linked SW Modules",
  Add_SW_MODULE: "Action to Add SW Module",
  ADD_SW_MODULE_DRAFT: "Action to Add SW Module Draft",
  Update_SW_MODULE: "Action to Update SW Module",
  REPLACE_SW_MODULE: "Action to Replace SW Module",
  LINK_SW_MODULE: "Action to Link SW Module",
  UNLINK_SW_MODULE: "Action to UnLink SW Module",
  GET_EE_COMPONENTS_MAIN: "Action to Get EE Components Main",
  GET_EE_COMPONENTS_LINKED: "Action to Get EE Components Linked",
  GET_EE_COMPONENTS_MAIN_LINKED: "Action to Get EE Components Main Linked",
  RESET_LAB_CAR_DATA: "Action to Reset Lab Car Data",
  SET_SELECTED_PROJECT: "Select a project for entire app",
  SET_SELECTED_VARIANT: "Select a variant for entire app",
  GET_EE_ACTIONS: "Get EE Actions Details",
  GET_GIT_SWM_LOGS: "Get the Git Software Modules logs",
  APPROVE_GIT_SWM_LOGS: "Approve the Git Software Modules logs",
  // Vehicle Systems
  GET_VEHICLE_SYSTEMS_PR: "Action to Get Vehicle Systems pr",
  SET_SELECTED_VEHICLE_SYSTEM: "Action to Set Selected Vehicle System",
  // Vehicle Components
  GET_VEHICLE_COMPONENTS: "Action to Get Vehicle Components",
  //Type Approval
  GET_CREATE_INTERSECTIONS: "Action to View the intersection details",
  CREATE_INTERSECTIONS:
    "Action to Link the software modules with the legal requirements",
  GET_TICKETS: "Action to Get Tickets",
  UPDATE_PROJECT_STATUS_TICKETS: "Action to Update Project Status",
  RE_CREATE_TICKETS: "RE_CREATE_TICKETS",
  DELETE_DRAFT_TICKETS: "Action to delete draft tickets",

  // Legal Standard
  GET_LEGAL_STANDARD_DETAILS: "Action to Get Legal Standard Details",
  GET_LEGAL_STANDARD_MAIN_DETAILS: "Action to Get Legal Standard Main Details",
  ADD_LEGAL_STANDARD: "Action to Add Legal Standard",
  UPDATE_LEGAL_STANDARD: "Action to Update Legal Standard",
  // Legal Requirements
  GET_LEGAL_REQUIREMENTS_DETAILS: "Action to Get Legal Requirement Details",
  GET_LEGAL_REQUIREMENTS_MAIN_DETAILS:
    "Action to Get Legal Requirement Main Details",
  GET_LEGAL_REQUIREMENTS_MAIN_DETAILS_ALL:
    "Action to Get Legal Requirement Main Details All",
  ADD_LEGAL_REQUIREMENTS: "Action to Add Legal Requirements",
  UPDATE_LEGAL_REQUIREMENTS: "Action to Update Legal Requirements",
  GET_LEGAL_STANDARD_TABLE_DETAILS:
    "Action to Get Legal Standard Table Details",
  GET_LEGAL_STANDARD_FOR_INTERSECTIONS:
    "Get Legal Standard for Intersection in Project",
  GET_LEGAL_REQUIREMENT_FOR_INTERSECTIONS:
    "Get Legal Requirement for Intersection in Project",
  ADD_LEGAL_STANDARD_TABLE: "Action to add Legal Standard Table",
  ADD_LEGAL_STANDARD_TABLE_ROW: "Action to add legal standard table row",
  ADD_LEGAL_STANDARD_TABLE_COLUMN: "Action to add legal standard table column",
  ADD_LEGAL_STANDARD_TABLE_CELLS: "Action to add legal standard table cells",

  //S/W to S/W Intersections
  GET_SOFTWARE_INTERSECTIONS:
    "Action to Get Software To Software Intersections",
  GET_SOFTWARE_LR: "Action to Get Software LR",

  //MFT_DETAILS
  ADD_MFT_DETAILS: "Action to Add Mft Details",
  DELETE_MFT_DETAILS: "Action to Delete Mft Details",
  GET_MFT_DETAILS: "Action to Get Mft Details",

  //Delivery Market Details
  ADD_DELIVERY_MARKET_DETAILS: "Action to Add Delivery Market Details",
  DELETE_DELIVERY_MARKET_DETAILS: "Action to Delete Deleiver Market",
  GET_DELIVERY_MARKET_DETAILS: "Action to Get Delivery Market Details",

  GET_USERS_DETAILS_LIST: "Action to Get Users Details",

  //Notifications details
  GET_RECENT_NOTIFICATIONS: "Action to get recent notifications",
  GET_ALL_NOTIFICATIFICATIONS: "Action to get all notifications",
  NOTIFICATIONS_MARK_READ: "Action to mark read notifications",
  DELETE_NOTIFICATION_FROM_QUEUE: "Action to delete notification from queue",

  //Action Type
  update_action_type: "Action to update action type",
  UPDATE_SWM_ACTION_TYPE: "Action to update swm action type",

  // Edit Requests
  GET_EDIT_REQUESTS: "Action to get edit requests",
  CREATE_EDIT_REQUESTS: "Action to create edit requests",
  APPROVE_EDIT_REQUESTS: "Action to approve edit request",
  REJECT_EDIT_REQUESTS: "Action to reject edit request",

  //Dynamic Template In Settings
  GET_DYNAMIC_TEMPLATE: "Get the Dynamic Forms In Settings",
  ADD_DYNAMIC_TEMPLATE: "Add the Dynamic Forms In Settings",
  UPDATE_DYNAMIC_TEMPLATE: "Update the Dynamic Forms In Settings",
  UPDATE_STATUS_DYNAMIC_TEMPLATE: "Update Status the Dynamic Forms In Settings",

  // Type approval dynamic templates for intersections
  GET_DEFAULT_TEMPLATES: "Get Default Templates",
  GET_My_TEMPLATES: "Get My Templates",

  //Reports
  GET_DF_REPORTS: "Get the Dynamic Forms In Reports",

  //Search
  SET_SEARCH_TICKET_ID: "Search Ticket ID",
  SET_SEARCH_INTR_ID: "Search Intesection ID",

  //Supplier Settings
  ADD_SUPPLIER_DETAILS: "To Add Supplier Details",
  DELETE_SUPPLIER_DETAILS: "To Delete Supplier Details",
  GET_SUPPLIER_DETAILS: "To Get Supplier Details",

  //Smart Matching
  SMART_RECREATE_PROJECT: "Add The Smart Match Project",
  SMART_RECREATE_VARIANT: "Add The Smart Match Variant",

  SMART_RECREATE_EE: "Add The Smart Match EE",
  SMART_RECREATE_SWM: "Add The Smart Match SWM",
  SMART_RECREATE_ZONES: "Add the Smart Match Zones",
  SMART_RECREATE_UPDATE_ZONES: "Update the Smart Match Zones",
  SMART_GET_CHILD_VARIANT: "Get Child Variant Details fro Smart Match",
  SMART_GET_CHILD_EE: "Get CHild EE Details for Smart Match",
  SMART_GET_PARENT_EE: "Get Parent EE Details",
  SMART_GET_PARENT_SWM: "Get Parent SWM Detaisl",
  SMART_GET_CHILD_SWM: "Get Child SWM Detaisl",
  SMART_UPDATE_STATUS: "Update Smart Match Status",
  SMART_UPDATE_WORKFLOW: "Update Workflow Status",
  SMART_ADD_WORKFLOW: "Add Workflow",
  SMART_GET_WORKFLOW: "Get Workflow",
  SMART_GET_CHILD_VS: "Get Child VS Details ",
  SMART_GET_PARENT_VS: "Get Parent VS Details",
  SMART_GET_PARENT_VC: "Get Parent VC Details",
  SMART_GET_CHILD_VC: "Get Child VC Detaisl",
  SMART_RECREATE_VS: "Add The Smart Match VS",
  SMART_RECREATE_VC: "Add The Smart Match VC",
  // Test cases
  GET_TEST_CASES: " Get test cases",
  ADD_TEST_CASE: " Add test case",
  UPDATE_TEST_CASE: " Update test case",
  GET_TEST_CAMPAIGNS: "Get test campaigns",
  ADD_TEST_CAMPAIGN: " Add test campaign",
  GET_CAMPAIGN_TEST_CASES: "Get campaign test cases",
  //Rule Engine
  GET_RULE_SET: "Get Rule Sets",
  GET_RULE_SET_with_standards: "Get Rule Sets with standards",
  ADD_RULE_SET: "Add Rule Set",
  ADD_ROOT_QUESTION: "Add Root Question",
  ADD_BRANCH_QUESTION: "Add Branch Question",
  GET_RULE_SET_TREE: "Get Rule Set Tree",
  UPDATE_ROOT_QUESTION: "Update Root Question",
  UPDATE_QUESTION_OR_CATEGORY: "Update Question or Category",
  //Network Interfaces
  ADD_NETWORK_INTERFACES: "Successfully added Network Interfaces",
  GET_NETWORK_INTERFACES: "Successfully retrieved Network Interfaces",
  GET_EE_NETWORK_INTERFACES: "Successfully retrieved EE Network Interfaces",
  GET_SWM_NETWORK_INTERFACES: "Successfully retrieved SWM Network Interfaces",
  DELETE_NETWORK_INTERFACES: "Successfully deleted Network Interfaces",

  // MFA
  MFA_ACTIONS: "MFA Actions",
  DELETE_MODULE: "Delete Module",
  DELETE_FEATURE: "Delete Feature",
  DELETE_ACTION: "Delete Action",
  CREATE_MODULE: "Create Module",
  CREATE_FEATURE: "Create Feature",
  CREATE_ACTION: "Create Action",
  GET_MODULE_MAPPING: "Get Module Mapping",

  // Role
  GET_ROLE_MODULE_MAPPING: "Get Role Module Mapping",
  UPDATE_ROLE_V2: "Update Role",
  CREATE_ROLE: "Create Role",
  //Integrations
  GET_CONNECTORS: "Fetch or display a list of all available connectors",
  TEST_CONNECTORS:
    "Test if a particular connector is working or can successfully connect",
  ADD_INTEGRATION: "Add a new integration configuration",
  GET_INTEGRATION: "Retrieve details of an existing integration",
  UPDATE_INTEGRATION: "Update an existing integration configuration",
  SAVE_INTEGRATION: "Save the integration details to the database",

  //Xray Sync
  SYNC_TEST_CASES_FROM_XRAY: "Sync test cases from Xray",
  IMPORT_SINGLE_TEST_CASE: "Import single test case from Xray",
  IMPORT_MULTIPLE_TEST_CASES: "Import multiple test cases from Xray",
  ADD_GIT_WEBHOOK: "ADD_GIT_WEBHOOK",
  // Smart Match Suggestions
  GET_SMART_MATCH_SUGGESTIONS: "Get Smart Match Suggestions",
  CLEAR_SMART_MATCH_SUGGESTIONS: "Clear Smart Match Suggestions",
  SMART_MATCH_SUBMIT_FEEDBACK: "Submit Smart Match Feedback",

  //Policies
  GET_POLICIES: "Get Policies",
  GET_ACTIONS: "Get Policies Key",
  ADD_POLICIES: "Add Policies",
  UPDATE_POLICIES: "Update Policies",
  DELETE_POLICIES: "Delete Policies",
  GET_DOMAINS: "Get Domains",

  //Roletype
  ADD_ROLETYPE: "Add RoleType",
  GETALL_ROLETYPE: "Get AllRoleType",
  GET_ROLETYPE: "Get RoleType",
  UPDATE_ROLETYPE: "Update RoleType",
  DEACTIVATE_ROLETYPE: "Deactivate",
  ATTACH_ROLETYPE: "Attach RoleType",
  DETACH_ROLETYPE: "Detach RoleType",

  //Roles New
  ADD_ROLE_DDH_UCM: "Add New Role",
  LIST_ROLE_DDH_UCM: "List New Role",
  GET_ROLE_DDH_UCM: "Get New Role",
  PUT_ROLE_DDH_UCM: "Update New Role",
  DELETE_ROLE_DDH_UCM: "Delete New Role",
  GET_ROLE_LR_DDH_UCM: "Get Role LR",
  ADD_ROLE_LR_DDH_UCM: "Add Role LR",
  DELETE_ROLE_LR_DDH_UCM: "Delete Role LR",
  GET_ROLE_RP_DDH_UCM: "Get Role RP",
  ADD_ROLE_RP_DDH_UCM: "Add Role RP",
  DELETE_ROLE_RP_DDH_UCM: "Delete Role RP",
  //Reports

  GET_REPORT_TEMPLATE: "Get the Report Templates",
  GET_LIVE_STREAM_QUEUE: "Get the Live Stream Queue",
};
export default actionType;
